var capitalize = require('./capitalize');
var underscored = require('./underscored');
var trim = require('./trim');

module.exports = function humanize(str) {
  return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/humanize.js
 ** module id = 1080
 ** module chunks = 0
 **/